const React = require("react");

function CurrencyRupeeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 8h6m-5 0a3 3 0 110 6H9l3 3m-3-6h6m6 1a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

module.exports = CurrencyRupeeIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/CurrencyRupeeIcon.js
 ** module id = 499
 ** module chunks = 0
 **/